<template>
    <v-container fluid>
      <v-card class="pl-6 pr-6 pt-6 pb-6">
        <!-- <v-card class="ma-5" elevation="0"> -->
        <v-row>
          <v-col cols="12" md="6">
            <v-card-title class="text-h5">Mapping Keyword</v-card-title>
          </v-col>
          <v-col align="right"  cols="12" md="6" class="d-flex justify-end mb-6  mt-2"> 
            <v-btn
              v-if="authorize_add"
              to="/new-keyword"
              rounded
              color="#0A7EA5"
              dark
              class="mb-2 ml-2"
            >
              <span>Add</span>
              <v-icon small center>add</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col cols="12" md="6">
            <v-text-field
              class="widthsizesearch heightsizesearch"
              v-model="search_ct"
              outlined
              dense
              label="Search"
              v-on:keyup.enter="onSearch"
            ></v-text-field>
            <h4 class="text-danger red--text">
              * input text and enter for search
            </h4>
          </v-col> -->
          <v-col cols="12" md="8">
            <v-text-field
              class="widthsizesearch heightsizesearch"
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
  
        <br />
  
        <v-card outlined tile>
          <v-data-table
            :items-per-page-options="pageSizes"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :search="search"
            :headers="headers"
            :items="mDataArray"
            class="elevation-1"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }"
                @click="openeditItem('Data',item)"
                v-if="authorize_view"
                class="mr-2"
              >
                mdi-calendar-check
              </v-icon>
              <v-icon
                :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }"
                @click="openeditItem('Edit',item)"
                v-if="authorize_edit"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
          <v-progress-linear
            indeterminate
            color="teal"
            v-if="load_bg"
          ></v-progress-linear>
        </v-card>
  
        <v-dialog v-model="dialogAddData" max-width="700px">
          <v-card>
            <br />
            <v-card-title class="text-h6">Address Information</v-card-title>
            <v-card-text>
              <v-container>
                <v-row justify="space-around" class="heightsize70formadvance">
                  <v-col cols="12" sm="4" md="4">
                    <h3><span class="vali">*</span>Contact Type</h3>
                    <v-select
                      v-model="itemdata.contact_type"
                      :items="contact_type"
                      item-text="contact_typename"
                      item-value="contact_typenumber"
                      outlined
                      dense
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="8" md="8"></v-col>
                </v-row>
  
                <v-row justify="space-around" class="heightsize70formadvance">
                  <v-col cols="12" sm="6" md="6">
                    <h3><span class="vali">*</span>Contact Name</h3>
                    <v-text-field
                      v-model="itemdata.contact_name"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6s">
                    <h3>Contact Person</h3>
                    <v-text-field
                      v-model="itemdata.contact_person"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="space-around" class="heightsize70formadvance">
                  <v-col cols="12" sm="6" md="6">
                    <h3>Position</h3>
                    <v-text-field
                      v-model="itemdata.position"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6s">
                    <h3>Email</h3>
                    <v-text-field
                      v-model="itemdata.email"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col cols="12" sm="6" md="6">
                    <v-row class="heightsize70formadvance">
                      <v-col cols="12" sm="12" md="12">
                        <h3><span class="vali">*</span>Address</h3>
                        <v-textarea
                          v-model="itemdata.address"
                          multi-line
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" md="6s">
                    <v-row class="heightsize70formadvance">
                      <v-col cols="12" sm="12" md="12">
                        <h3><span class="vali">*</span>City</h3>
                        <v-text-field
                          v-model="itemdata.city"
                          append-icon=""
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="heightsize70formadvance">
                      <v-col cols="12" sm="12" md="12">
                        <h3>Country</h3>
                        <v-text-field
                          v-model="itemdata.country"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col cols="12" sm="6" md="6">
                    <h3>Telephone</h3>
                    <v-text-field
                      v-model="itemdata.telephone"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6s">
                    <h3>Fax</h3>
                    <v-text-field
                      v-model="itemdata.fax"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                width="100"
                class="mr-3 buttonblue"
                @click="saveaddItem()"
              >
                Save
              </v-btn>
              <v-btn depressed outlined width="100" @click="closeaddItem()">
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
  
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
      <!-- popup add -->
          <v-dialog v-model="dialogAddKeyword" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Add Keyword</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Object Type :</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-autocomplete
                        clearable
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Notice Type :</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-autocomplete
                        clearable
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Keyword</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-text-field
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text>
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      <!-- </v-card> -->
      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />
      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-container>
  </template>
  
<script>
  import api from "@/services/api";
  import { server } from "@/services/constants";
  import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
  import SuccessDialog from "@/components/cards/SuccessDialog";
  
  export default {
    name: "MappingList",
    async mounted() {
      this.$showLoader();
      await api.checkVersion();
  
      // ----------------- Check Authorize ---------------------------
      this.userId = localStorage.getItem(server.USER_ID);
      let yourUrlString = window.location;
      // alert(yourUrlString);
  
      let parser = document.createElement("a");
      parser.href = yourUrlString;
  
      this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
      // alert("authorize_id:" + this.authorize_id);
      if (this.authorize_id == null || this.authorize_id == 0) {
        // this.$router.push("/login");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Authorize Failed",
          "Please Logout And Login Again",
          "text-h5 red--text text-center"
        );
        this.$router.back();
      }
  
      const router_path = parser.pathname.replace("/", "");
  
      const res_auth = await api.getAuthorize(this.userId, router_path);
  
      console.log("res_auth:" + JSON.stringify(res_auth.data));
  
      this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
      this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
      this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
      this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
  
      // console.log("res_auth:" + JSON.stringify(res_auth.data));
      // console.log("authorize_view:" + this.authorize_view);
      // console.log("authorize_add:" + this.authorize_add);
      // console.log("authorize_edit:" + this.authorize_edit);
      // console.log("authorize_del:" + this.authorize_del);
      // this.$router.back();
  
      if (!this.authorize_view) {
        this.$router.back();
      }
  
      // // ----------------- Check Authorize ---------------------------
      await this.loaddata();
      this.$hideLoader();
    },
    components: { SuccessDialog, SuccessDialogPush },
    data() {
      return {
        userId: 0,
        authorize: [],
        authorize_view: false,
        authorize_add: false,
        authorize_edit: false,
        authorize_del: false,
        authorize_id: 0,
        load_bg: false,
        dialogAddKeyword: false,
        dialogAdd: false,
        dialogAddData: false,
        dialogDelete: false,
        isShowPassword: false,
        fullPage: true,
        search: "",
        mDataArray: [],
        text_color: "text-h5 green--text text-center",
        title: "green",
        message: "green",
        link: "",
        search_ct: "",
        itemdata: {
          contact_type: 0,
          contact_name: "",
          contact_person: "",
          position: "",
          email: "",
          address: "",
          city: "",
          country: "",
          telephone: "",
          fax: "",
          status: "A",
        },
        edititemdata: {
          contact_type: 0,
          contact_name: "",
          contact_person: "",
          position: "",
          email: "",
          address: "",
          city: "",
          country: "",
          telephone: "",
          fax: "",
        },
        contactid_del: 0,
        oparation: "",
        headers: [
          {
            text: "Work Type",
            value: "documenttype_code",
            class: "bg-colorth",
            divider: true,
            // width: "8%",
          },
          {
            text: "Notice Type",
            value: "notice_code",
            class: "bg-colorth",
            divider: true,
            // width: "10%",
          },
          
          {
            text: "",
            value: "actions",
            class: "bg-colorth",
            divider: true,
            align:"center",
            width: "140px",
          },
        ],
      };
    },
    methods: {
      async loaddata() {
        // this.$showLoader();
        this.load_bg = true;
        var tmp = [];
        const result = await api.getOCRKWList();
        this.mDataArray =  result.data;
        console.log(this.mDataArray)
        this.load_bg = false;
      },
      async openeditItem(mode,item) {
        if(mode == "Edit"){
          this.$router.push(`/edit-keyword/${mode}/${item.doctype_id}/${item.notice_type}`);
        }else{
          this.$router.push(`/show-keyword/${mode}/${item.doctype_id}/${item.notice_type}`);
        }
      },
      setupAlertDialogPush(status, title, message, text_color, link) {
        this.title = title;
        this.message = message;
        this.dialogAdd = status;
        this.text_color = text_color;
        this.link = link;
      },
      setupAlertDialog(status, title, message, text_color) {
        this.title = title;
        this.message = message;
        this.dialogAdd = status;
        this.text_color = text_color;
      },
    },
    beforeCreate() {
      this.$store.state.navMenu = true;
    },
  };
</script>
  
  <style scoped>
  .widthbtnimagefile {
    width: 40%;
  }
  .widthsizesearch {
    width: 70%;
  }
  .v-btn:not(.v-btn--round).v-size--default.buttonblue {
    background-color: #1d2442;
    color: white;
  }
  .btnuploadfile {
    border: 2px solid;
  }
  .heightsize70formadvance {
    height: 80px;
  }
  
  .vali {
    color: red;
  }
  
  h3 {
    font-size: 1.17em;
  }
  
  .heightsizesearch {
    height: 45%;
  }
  </style>
  